// extracted by mini-css-extract-plugin
export default {"fullWidth":"vp-z","image":"wp-z","lazyLoadPicture":"xp-z","lazyLoadSpinner":"yp-z","lazyLoadSpin":"zp-z","lazyLoadImage":"Ap-z","hasStyledAspectRatio":"Bp-z"};